<template>
  <div class="columns is-multiline">
    <div class="column is-4 pdv-1">
      <b-field
        :label="$t('detailCommande.indexation.nomIndice')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ libelle }}
        </span>
      </b-field>
    </div>
    <div class="column is-4 pdv-1">
      <b-field
        :label="$t('detailCommande.indexation.valeurIndexationReference')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ itemIndexe.valeurIndexationReference }}
        </span>
      </b-field>
    </div>
    <div class="column is-4 pdv-1">
      <b-field
        :label="$t('detailCommande.indexation.dateIndexationReference')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ func.formatDate(itemIndexe.dateIndexationReference) }}
        </span>
      </b-field>
    </div>
    <div class="column pdv-1 is-4">
      <b-field
        :label="$t('detailCommande.indexation.dateDerniereIndexation')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ func.formatDate(itemIndexe.dateDerniereIndexation) }}
        </span>
      </b-field>
    </div>
    <div class="column is-4 pdv-1">
      <b-field
        :label="$t('detailCommande.indexation.valeurIndexationActuel')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ itemIndexe.valeurIndexationActuel }}
        </span>
      </b-field>
    </div>
    <div class="column pdv-1 is-4">
      <b-field
        :label="$t('detailCommande.indexation.dateIndexationActuel')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ func.formatDate(itemIndexe.dateIndexationActuel) }}
        </span>
      </b-field>
    </div>
  </div>
</template>

<script>
import formatDate from '@/services/general/formatDate';

export default {
  props: {
    itemIndexe: {
      type: Object,
      required: true,
    },
    libelle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      func: {
        formatDate,
      },
    };
  },
};
</script>
